export const ACTIVITIES_GET = 'ACTIVITIES_GET';
export const ACTIVITY_GET = 'ACTIVITY_GET';